import React, { useMemo } from 'react'
import { FormCheckboxField, FormSelectField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { CountryDto } from 'api/Identity/Types/Country'
import { TeamDto } from 'api/Identity/Types/Team'

import { ModalData } from './ClientDetailsDashboardForm'

interface Props {
  isOpen?: boolean
  onClose(): void
  data: ClientDetailedDto
  modalData: ModalData
  countries: CountryDto[]
  teams: TeamDto[]
  disabled: boolean
  setModalData(data: ModalData): void
  saveModalForm(): void
}

export const ClientDetailsDashboardAddEditNationalityTeam: React.FC<Props> = ({
  isOpen,
  onClose,
  data,
  modalData,
  countries,
  teams,
  disabled,
  setModalData,
  saveModalForm,
}) => {
  const options = modalData.type === 'nationality' ? countries : teams
  const existingIds = useMemo(
    () =>
      new Set(
        (modalData.type === 'nationality' ? data.nationalities : data.teams)
          .map((item) => item.id)
          .filter((id) => id !== modalData.editId)
      ),
    [data.nationalities, data.teams, modalData.editId, modalData.type]
  )

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {modalData.editId
              ? `Edit ${modalData.type === 'nationality' ? 'Nationality' : 'Team'}`
              : `Add ${modalData.type === 'nationality' ? 'Nationality' : 'Team'}`}
          </DialogTitle>
        </DialogHeader>
        <div className='flex flex-col gap-4'>
          <FormSelectField
            label={modalData.type === 'nationality' ? 'Nationality' : 'Team'}
            value={modalData.data.id}
            options={options.map((option) => ({
              id: option.id,
              name: option.name,
              disabled: existingIds.has(option.id),
            }))}
            disabled={disabled}
            showSearch
            allowClear
            onChange={(value) => {
              const selectedOption = options.find((option) => option.id === value)
              setModalData({
                ...modalData,
                data: {
                  ...modalData.data,
                  name: selectedOption?.name ?? '',
                  id: selectedOption?.id ?? '',
                },
              })
            }}
          />
          <FormCheckboxField
            label='Primary'
            disabled={disabled}
            value={modalData.data.isPrimary}
            onChange={(checked) =>
              setModalData({
                ...modalData,
                data: { ...modalData.data, isPrimary: checked },
              })
            }
          />
        </div>
        <DialogFooter>
          <Button onClick={onClose} type='button' variant='outline'>
            Cancel
          </Button>
          <Button type='button' onClick={saveModalForm} disabled={disabled || !modalData.data.id}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
